import React, {
  useState,
  useEffect,
  memo,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { Form, Input, Radio } from 'antd';
import { Button } from 'appkit-react';
// import '@style/components/iaOptions.scss';
import '../../../../styles/components/iaOptions.scss';
const ERROR_MSG = {
  REQUIRED: 'Element name is required',
  TITLE: 'The name has already existed',
  DUPLICATED_OPTIONS: 'Option already exists in element',
  NULL_OPTION: 'Option cannot be empty',
  LACK_OPTION: "There's at least one option",
};
/* eslint-disable react-hooks/exhaustive-deps */

// process form data for submit
const spawnSubmitOption = (formValues, radioValue, originData) => {
  const { userAdded, isShow } = originData || {};
  const optionData = {
    title: formValues.optionName,
    userAdded: typeof userAdded === 'undefined' ? true : userAdded,
    isShow: typeof isShow === 'undefined' ? true : isShow,
    content: [],
    canCheckMore: radioValue !== 'single',
    subtitle:
      radioValue === 'single'
        ? null
        : 'This line can be a selection of all options',
  };
  Object.entries(formValues).forEach(([fieldName, fieldValue]) => {
    if (fieldName !== 'optionName') {
      optionData.content.push({
        name: fieldValue,
        data: {
          value: null,
          questioned: false,
          isSelected: false,
        },
      });
    }
  });
  return optionData;
};

const AddNewElement = (
  {
    isEditing,
    addCallback,
    data,
    allElementNames,
    cancelCallback,
    sectionIndex,
    ...props
  },
  ref,
) => {
  const [form] = Form.useForm();
  const [options, setOptions] = useState({
    optionName: '',
    option1: '',
    option2: '',
  });
  const [radioValue, setRadioValue] = useState('single');
  // const [errorMsg, setErrorMsg] = useState('');
  // const [canAddMoreOption, setCanAddMoreOption] = useState(true);

  useImperativeHandle(
    ref,
    () => ({
      validate: async () => {
        try {
          const formValues = await form.validateFields();
          return spawnSubmitOption(formValues, radioValue, data);
        } catch (e) {
          console.warn(e);
          return null;
        }
      },
    }),
    [form, radioValue, data],
  );

  const formattedAllElementNames = [];
  for (const k in allElementNames) {
    for (const j in allElementNames[k]) {
      formattedAllElementNames.push(allElementNames[k][j]);
    }
  }
  useEffect(() => {
    if (form && data.title) {
      const tempOption = {
        optionName: data.title,
      };
      for (const i in data.content) {
        tempOption[`option${parseInt(i) + 1}`] = data.content[i].name;
      }
      form.setFieldsValue(tempOption);
      setOptions(tempOption);
      if (data.canCheckMore) {
        setRadioValue('multiple');
      }
    } else {
      // console.log(Object.values(form.getFieldsValue()).filter((o) => o).length);
      if (Object.values(form.getFieldsValue()).filter((o) => o).length === 0) {
        form.setFieldsValue(options);
      }
    }
  }, [data, form]);
  const OptionComp = useCallback(
    ({ name, value, index }) => (
      <Form.Item
        className="option-block"
        // preserve={false}
        name={name}
        label={
          <>
            {`Option ${index}`}
            <div className="add-option">
              <span
                className="appkiticon icon-circle-delete-fill"
                onClick={() => {
                  removeOption(name);
                }}
              />
            </div>
          </>
        }
        initialValue={value}
        rules={[
          {
            validator: (_, value) => {
              const fieldsValue = Object.values(form.getFieldsValue());
              fieldsValue.shift();
              const res = fieldsValue.filter((v) => v === value);
              if (!value) {
                return Promise.reject(new Error(ERROR_MSG.NULL_OPTION));
              }
              if (res.length > 1) {
                return Promise.reject(new Error(ERROR_MSG.DUPLICATED_OPTIONS));
              }
              return Promise.resolve();
            },
            validateTrigger: 'none',
          },
        ]}
      >
        <Input maxLength={40} />
      </Form.Item>
    ),
    [form],
  );
  const onRadioChange = (e) => {
    setRadioValue(e.target.value);
  };
  const addOption = () => {
    if (Object.keys(options).length < 5) {
      const tempOption = form.getFieldsValue();
      options[`option${Object.keys(options).length}`] = '';
      setOptions({ ...options });
      setTimeout(() => {
        form.setFieldsValue(tempOption);
      });
    }
  };
  const removeOption = (name) => {
    const tempOption = form.getFieldsValue();
    const newOptions = {};
    if (Object.keys(tempOption).length < 4) {
      return;
    }
    delete tempOption[name];
    const newLength = Object.keys(tempOption).length;
    newOptions.optionName = tempOption.optionName;
    for (let i = 1; i < newLength; i++) {
      newOptions[`option${i}`] = tempOption[Object.keys(tempOption)[i]];
    }
    setOptions({ ...newOptions });
    form.setFieldsValue(newOptions);
  };
  const submitAdd = () => {
    form
      .validateFields()
      .then((res) => {
        const formValues = form.getFieldsValue();
        addCallback(spawnSubmitOption(formValues, radioValue, data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      <div
        className={`new-element-option-row approach-edit-element-${sectionIndex}`}
      >
        <div
          className="appkiticon delete-icon icon-circle-delete-fill"
          onClick={cancelCallback}
        />
        <Form
          name="newElementForm"
          form={form}
          layout="vertical"
          autoComplete="off"
          preserve={false}
        >
          <div className="option-row-content">
            <Form.Item
              className="option-block"
              name="optionName"
              label={
                <>
                  Element Name
                  <div
                    className={`add-option ${
                      Object.keys(options).length === 5 ? 'disabled' : ''
                    }`}
                    onClick={addOption}
                  >
                    <span className="appkiticon icon-plus-fill" />
                    Add Option
                  </div>
                </>
              }
              rules={[
                {
                  validator: (_, value) => {
                    const sameValue = formattedAllElementNames.filter(
                      (f) => f === value,
                    );
                    const fieldsValue = form.getFieldsValue();
                    if (Object.keys(fieldsValue).length < 2) {
                      return Promise.reject(new Error(ERROR_MSG.LACK_OPTION));
                    }
                    if (sameValue.length > 0) {
                      return Promise.reject(new Error(ERROR_MSG.TITLE));
                    }
                    if (value.trim() === '') {
                      return Promise.reject(new Error(ERROR_MSG.REQUIRED));
                    }
                    return Promise.resolve();
                  },
                  validateTrigger: 'none',
                },
              ]}
            >
              <Input maxLength={40} />
            </Form.Item>
            {Object.keys(options).map((key, i) =>
              key !== 'optionName' ? (
                <OptionComp
                  key={key}
                  name={key}
                  value={options[key]}
                  index={i}
                />
              ) : null,
            )}
          </div>
          <div className="button-area">
            <Button
              size="lg"
              onClick={submitAdd}
              style={{
                width: '4.875rem',
                marginTop: '1.938rem',
                alignSelf: 'flex-end',
              }}
            >
              {typeof data.originRowId === 'undefined' ? 'Add' : 'Save'}
            </Button>
          </div>
          <div className="radio-area">
            <Radio.Group onChange={onRadioChange} value={radioValue}>
              <Radio value="single">Single Choice</Radio>
              <Radio value="multiple">Multiple Choice</Radio>
            </Radio.Group>
          </div>
        </Form>
      </div>
      {/* <div className="error-area">{errorMsg}</div> */}
    </>
  );
};

export default memo(forwardRef(AddNewElement));
